<!-- 
Chart showing exception counts by level (error, debug etc)
-->
<template>
  <v-flex>
    <v-card>
      <our-widget-toolbar fixed for-dialog title="Exception counts by level" @refresh="refresh" />
      <our-busy-indicator :show="!loaded"/>
      <v-card-text class="pb-3">
        <doughnut-chart ref="chart" :chart-data="chartData" style="height: 265px" />
      </v-card-text>
      <slot/>
    </v-card>
  </v-flex>
</template>

<script>
import _ from "underscore";
import axios from "axios";
import * as helpers from "@/store/exception-logs/helpers";
import DoughnutChart from "@/components/common/chart/DoughnutChart.vue";

export default {
  components: {
    DoughnutChart
  },
  data() {
    return {
      chartData: {},
      loaded: false
    };
  },
  watch: {
    loaded() {
      if (this.loaded) {
        this.$nextTick(this.drawChart);
      }
    }
  },
  mounted() {
    this.loaded ? this.drawChart() : this.refresh();
  },
  methods: {
    refresh: async function() {
      this.loaded = false;
      const { data } = await axios.get("/api/exception-logs/statistics/counts-by-level");
      const d = _.pick(data, _.identity);
      const labels = _(_(d).keys()).map(level => level[0].toUpperCase() + level.substr(1));
      const backgroundColors = _(labels).map(key => helpers.ExceptionChartColors[key]);
      const datasets = [{ data: _(d).values(), backgroundColor: backgroundColors }];
      this.chartData = { labels, datasets };
      this.loaded = true;
    },
    drawChart: function() {
      this.$refs.chart.display();
    }
  }
};
</script>
